/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

const kUrl = 'url';
const kHttpUrl = 'httpUrl';

export const setUrl = (url) => {
  sessionStorage.setItem(kUrl, url);
};

export const setHttpUrl = (httpUrl) => {
  sessionStorage.setItem(kHttpUrl, httpUrl);
};

export const getUrl = () => sessionStorage.getItem(kUrl);

export const getHttpUrl = () => sessionStorage.getItem(kHttpUrl);

export default {
  setUrl,
  setHttpUrl,
  getUrl,
  getHttpUrl,
};




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/APIView/coms/AppDebug/func/url.js